module.exports = __webpack_public_path__ + "main/assets/public/email/twitter-logo.944ad4017886864b.png";